import { ensureTrailingSlash } from '../utils/urlHelper';
import ApiServiceBase from './apiServiceBase';
import { ISupplementalMaterialsOrderResponse } from './models/supplementalMaterials';
import { AxiosRequestConfig, Method } from 'axios';

export default class DocViewerApiServiceBase extends ApiServiceBase {
	constructor(basePath: string) {
		super(basePath);
	}

	protected createBaseRequest(): AxiosRequestConfig {
		const baseConfig = super.createBaseRequest();
		return {
			...baseConfig,
			baseURL: ensureTrailingSlash(baseConfig.baseURL) + '/services/documentviewer'
		};
	}

	public async doManualSupplementalMaterialsRequestAsync(
		orderId: number
	): Promise<ISupplementalMaterialsOrderResponse> {
		const request = {
			url: '/CheckSupplementalOrderAvalible',
			method: 'post' as Method,
			params: { orderId },
			...this.createBaseRequest()
		};

		const response = await super.sendAsync<ISupplementalMaterialsOrderResponse>(request);
		this.throwIfFailedResponse(response, localize('Error while manual supplemental materials request.'));

		return response.data ?? null;
	}
}
